import { Table } from 'antd';
import styled from 'styled-components';

export const SProductMenuTable = styled(Table)`
  flex: 1;

  /* Remove outer container border */
  .ant-table {
    border: none;
  }

  .ant-table-container {
    border-left: none !important;
    border-right: none !important;
  }

  /* Remove border-radius on header corners */
  .ant-table-container table > thead > tr:first-child th:first-child,
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0;
  }

  /* Header cells — bold dark bottom border, no vertical borders */
  thead > tr > th {
    font-weight: 600;
    border-right: none !important;
    border-bottom: 2px solid ${({ theme }) => theme.color.grey85} !important;
  }

  /* Body cells — bold dark bottom border, no vertical borders */
  .ant-table-tbody > tr > td {
    vertical-align: middle;
    border-right: none !important;
    border-bottom: 2px solid ${({ theme }) => theme.color.grey85} !important;
  }

  /* Last row — keep bottom border */
  .ant-table-tbody > tr:last-child > td {
    border-bottom: 2px solid ${({ theme }) => theme.color.grey85} !important;
  }
` as typeof Table;
